import React from 'react';
import { Space, Typography } from 'antd';

const { Title, Text } = Typography;

/** The page frame shared by the three GEO exposure screens (menu entries under GEO / SEO). */
export const GeoExposureLayout = ({ title, extra, children }) => (
    <div style={{ padding: 24 }}>
        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <div>
                <Title level={3} style={{ marginBottom: 0 }}>GEO exposure · {title}</Title>
                <Text type="secondary">How often ChatGPT mentions Design With Friends when people ask about interior design.</Text>
            </div>
            {extra}
        </Space>
        {children}
    </div>
);

export const formatDate = (value) => (value ? new Date(value).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '-');
export const formatDay = (value) => (value ? new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '-');
export const percent = (share) => (share == null ? '-' : `${Math.round(share * 100)}%`);

export const RUN_STATUS_COLORS = { running: 'processing', completed: 'success', failed: 'error', cancelled: 'default' };
